import Ajax from "./Ajax"
const GetCity = async(stateId, loader) => {
    const response = await Ajax({
        url: `/setting/getCity?limit=false&state=${stateId}`,
        token: true,
        ...(loader && {loader: true})
    })
    return response.data.result
}
export default GetCity